<template>
  <div>
    <b-tooltip label="Total comparables in list and how many are checked" position="is-top">
      <div class="level-left">
        <div style="margin-right: .5em">{{ $store.state.evaluation.rentCompGroup.rentComps.length }}</div>
        <i class="fas fa-list"></i>
        <div style="margin-left: 1em;margin-right: .5em">{{ getIncludedRentCompCount() }}</div>
        <i class="fas fa-check-square"></i>
        <button v-if="showMapButton" @click="toggleMap()" class="button is-primary" style="margin-left: 10px">
          {{ mapButtonText }}
        </button>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
import store from "@/store";

export default {
  components: {
    store
  },
  props: {
    showMapButton: false,
    isMapSectionExpanded: false
  },
  computed: {
    mapButtonText() {
      return !this.isMapSectionExpanded ? 'Show Map' : 'Hide Map'
    }
  },
  methods: {
    toggleMap() {
      this.$emit(
          "toggleMap"
      );
    },
    getIncludedRentCompCount() {
      var included = store.state.evaluation.rentCompGroup.rentComps.filter(
          sc => sc.include === true
      );
      return included.length;
    }
  }
};
</script>

<style>
</style>
